import { render, staticRenderFns } from "./documents.rdb.vue?vue&type=template&id=33924c4e"
import script from "./documents.rdb.vue?vue&type=script&lang=js"
export * from "./documents.rdb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports